import { TFiltersMethods, TFiltersStore } from "./filters.state";
import { filtersReducer } from "./filters.reducer";

// ✅ Reusable store methods
export const createFilterActions = (
    set: any,
    get: () => TFiltersStore
): Pick<TFiltersStore, TFiltersMethods> => ({
    dispatch: action => set((state: TFiltersStore) => filtersReducer(state, action)),

    getCompanyById: (id: number) => {
        return get().companies.find(item => item.id === id);
    },

    getIndustryById: (id: number) => {
        return get().industries.find(item => item.id === id);
    }
});
